<div class="main-container">
    <div class="title-section">
        <div class="head">
            <div class="reward-icon">
                <mat-icon svgIcon="starborder"></mat-icon>
            </div>
            <label class="font-poppins"> {{ "reward.heading.coupons&Rewards" | translate }} </label>
        </div>
        <p>{{ "reward.heading.subHeading" | translate }}</p>
    </div>

    <div class="top-section" *ngIf="rewards?.length">
        <div class="top-section-content">
            <div class="balance-content">
                <!-- Balance -->
                <div class="coin-balance">
                    <p>Your Coin Balance</p>
                    <div class="icon-number">
                        <div class="coin-icon">
                            <mat-icon svgIcon="coin"></mat-icon>
                        </div>

                        <span class="font-poppins"> {{ totalBalance }}</span>
                    </div>
                </div>

                <!-- Next balance -->
                <div class="next-balance">
                    <label>Next Reward</label>
                    <span>{{ totalBalance + 100 }}</span>
                </div>
            </div>
            <div class="balance-para">
                <p>You're just 100 coins away from your next reward! 🎉</p>
                <div class="line-bottom"></div>
            </div>
        </div>
    </div>

    <div class="bottom-section" *ngIf="rewards?.length; else noRewardTemplate">
        <div class="bottom-transaction-container">
            <div class="transaction-top font-poppins">
                <span>{{ "reward.heading.transationDetails" | translate }}</span>
                <span>{{ "reward.heading.coinsDetails" | translate }}</span>
            </div>

            <div class="transaction-bottom">
                <div class="reward-card">
                    <div *ngFor="let reward of rewards">
                        <div *ngIf="reward.type === RewardType.Credited" class="bg bg-credit">
                            <div class="transaction-details-left-section">
                                <div class="plus-icon">+</div>
                                <div class="structure-name">
                                    <p>Order ID: {{ reward.orderId }}</p>
                                    <span>{{ getDisplayName(reward) }}</span>
                                </div>
                            </div>
                            <div class="transaction-details-right-section">
                                <div class="icon-number">
                                    <mat-icon
                                        svgIcon="coin"
                                        [ngClass]="{
                                            'coin-positive': reward.type === RewardType.Credited
                                        }"
                                    >
                                    </mat-icon>

                                    <span
                                        [ngClass]="{
                                            positive: reward.type === RewardType.Credited
                                        }"
                                    >
                                        {{ reward.amount }}
                                    </span>
                                </div>

                                <div class="date">
                                    {{ reward.createdAt | date: "MMM dd, yyyy, hh:mm a" }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="reward.type === RewardType.Debited" class="bg bg-debit">
                            <div class="transaction-details-left-section">
                                <div class="plus-icon">-</div>
                                <div class="structure-name">
                                    <p>Order ID: {{ reward.orderId }}</p>
                                </div>
                            </div>
                            <div class="transaction-details-right-section">
                                <div class="icon-number">
                                    <mat-icon
                                        svgIcon="coin"
                                        [ngClass]="{
                                            'coin-negative': reward.type === RewardType.Debited
                                        }"
                                    >
                                    </mat-icon>

                                    <span
                                        [ngClass]="{
                                            negative: reward.type === RewardType.Debited
                                        }"
                                    >
                                        {{ reward.amount }}
                                    </span>
                                </div>

                                <div class="date">
                                    {{ reward.createdAt | date: "MMM dd, yyyy, hh:mm a" }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="load-btn">
                <button class="load-more-btn" *ngIf="showViewMoreButton()" (click)="loadMoreRewards()">
                    {{ "reward.button.viewMoreBtn" | translate }}
                </button>
            </div>
        </div>
    </div>

    <!-- No reward -->
    <ng-template #noRewardTemplate>
        <div class="no-rewards" *ngIf="!loading">
            <div class="no-reward-icon">
                <mat-icon svgIcon="giftbox"></mat-icon>
            </div>

            <div class="context">
                <h2 class="font-poppins">{{ "reward.heading.noReward" | translate }}</h2>
                <p>{{ "reward.heading.noRewardMessage" | translate }}</p>
            </div>

            <button class="back-btn" (click)="goToHomePage()">
                <mat-icon svgIcon="arrowleft"></mat-icon>
                {{ "reward.button.backToHomeBtn" | translate }}
            </button>
        </div>
        <div class="no-rewrd-bottom">
            <div class="common" (click)="goToBestSeller()">
                <div class="contents">
                    <div class="icon popular">
                        <mat-icon [svgIcon]="'fullstar'"></mat-icon>
                    </div>
                    <div class="para">
                        <p class="font-poppins">Popular Toys</p>
                        <span>Discover trending toys for kids</span>
                    </div>
                </div>
            </div>
            <div class="common" (click)="goToFeature()">
                <div class="contents">
                    <div class="icon offer">
                        <mat-icon svgIcon="offer"></mat-icon>
                    </div>
                    <div class="para">
                        <p class="font-poppins">Special Offers</p>
                        <span>Check out amazing deals</span>
                    </div>
                </div>
            </div>
            <div class="common" (click)="goToWishlist()">
                <div class="contents">
                    <div class="icon wish">
                        <mat-icon svgIcon="activewishlist"></mat-icon>
                    </div>
                    <div class="para">
                        <p class="font-poppins">Wishlist</p>
                        <span>Save toys for later</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
